import DialogWrapper from "@memorang/ui/components/DialogWrapper";
import { Dialog } from "react-native-paper";
import SortViewMainContent from "./SortViewMainContent";
import type { SortBy } from "./types";
import type { SortByDataType, SortOrderType } from "./types";

type TopicsSortDialogProps = {
	visible: boolean;
	handleClose: () => void;
	handleSortByChange: (type: SortBy) => void;
	data: SortByDataType[];
	selectedSortByItem?: SortByDataType;
	sortOrderType: SortOrderType;
};

const TopicsSortDialog = ({
	visible,
	handleClose,
	handleSortByChange,
	data,
	selectedSortByItem,
	sortOrderType,
}: TopicsSortDialogProps) => {
	return (
		<DialogWrapper
			visible={visible}
			handleClose={handleClose}
			showCloseButton={false}
			maxWidth="xs"
		>
			<Dialog.Title>Sort by</Dialog.Title>
			<SortViewMainContent
				handleSortByChange={handleSortByChange}
				data={data}
				selectedSortByItem={selectedSortByItem}
				sortOrderType={sortOrderType}
			/>
		</DialogWrapper>
	);
};

export default TopicsSortDialog;
